import { debounce } from './utils/utils';

document.querySelectorAll('.waiting-period-note').forEach(elem => {
  const toggle = elem.querySelector('.toggle');
  const contentToggle = elem.querySelector('.content-toggle');
  const copyCode = elem.querySelector('.copy-code');

  let initHeight;

  const setInitHeight = () => {
    if (elem.style.height) {
      elem.style.removeProperty('height');
    }
    initHeight = elem.offsetHeight;
    elem.style.height = `${initHeight}px`;
  };

  setInitHeight();

  if (toggle) {
    toggle.addEventListener('click', () => {
      elem.classList.toggle('active');
      contentToggle.classList.toggle('open');
      const openHeight = contentToggle.offsetHeight;
      elem.style.height = `${initHeight + openHeight}px`;
    });
  }

  if (copyCode) {
    copyCode.style.cursor = 'pointer';
    copyCode.addEventListener('click', () => {
      const code = copyCode.innerText;
      navigator.clipboard.writeText(code);
      const copyFeedback = document.createElement('div');
      copyFeedback.className = 'copy-feedback';
      copyFeedback.innerHTML = 'Gutscheincode kopiert';
      document.body.appendChild(copyFeedback);
      setTimeout(function () {
        document.body.removeChild(copyFeedback);
      }, 3000);
    });
  }

  window.addEventListener('resize', debounce(setInitHeight, 300));
});
